import * as React from 'react';
import Flex from 'antd/lib/flex';
import Text from 'antd/lib/typography/Text';
import { CaretDownOutlined } from '@ant-design/icons';
import { antGrey, navFlexItemStyle } from '../../styles/globalStyles';

interface DropdownButtonContentProps {
    icon: React.ReactNode;
    text: React.ReactNode;
    showCaret?: boolean;
    containerStyle?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    caretStyle?: React.CSSProperties;
    cursor?: React.CSSProperties['cursor'];
}

export const DropdownButtonContent: React.FC<DropdownButtonContentProps> = ({
    icon,
    text,
    showCaret = true,
    containerStyle,
    textStyle,
    caretStyle,
    cursor = 'pointer',
}) => {
    return (
        <Flex
            align="center"
            gap={12}
            style={{
                cursor,
                padding: 8,
                paddingRight: 12,
                minWidth: 0,
                backgroundColor: 'black',
                ...containerStyle,
            }}
        >
            {icon}
            <Text
                style={{
                    ...navFlexItemStyle,
                    color: antGrey.grey1,
                    fontSize: 16,
                    fontWeight: 500,
                    ...textStyle,
                }}
                ellipsis
            >
                {text}
            </Text>
            {showCaret && <CaretDownOutlined style={{ color: antGrey.grey7, fontSize: 16, ...caretStyle }} />}
        </Flex>
    );
};
